// extracted by mini-css-extract-plugin
export default {"divider":"SectionDivider_divider__8l07Y","svg":"SectionDivider_svg__m-Zay"};